import React, { useState } from "react";
import { Breadcrumb } from "@/components/base/Breadcrumb";
import { CreateDiagnosticInput } from "@/types/diagnostic";
import { newDiagnosticRepository } from "@/repositories/diagnostics";
import { client } from "@/api/client";
import { useRouter } from "next/router";
import { CreateDiagnosticResultInput } from "@/types/diagnostic_result";
import { QuestionsForm } from "@/components/diagnostics/QuestionsForm.busy";
import { ItemizedQuestions } from "@/data/busy";
import { Head } from "@/components/base/Head";

const BusyDiagnoseQuestionsPage = () => {
  const [loading, setLoading] = useState(false);
  const META_TITLE = "「忙しい！」レベル診断 設問ページ";
  const MAIN_COLOR = "#FF9966";
  const headings = ["忙しさ"];
  const category = "busy";
  const diagnosticRepository = newDiagnosticRepository(client);
  const router = useRouter();

  const breadcrumbs = [
    {
      title: META_TITLE,
    },
  ];

  const onSubmit = async (data: {
    companyName: string;
    email: string;
    scores: number[];
  }) => {
    try {
      const diagnostic: CreateDiagnosticInput = {
        company_name: data.companyName,
        email: data.email,
        category,
      };
      const diagnosticResults: CreateDiagnosticResultInput[] = headings.map(
        (heading, index) => {
          return {
            title: heading,
            score: data.scores[index],
          };
        }
      );

      await diagnosticRepository
        .createDiagnostic(diagnostic, diagnosticResults)
        .then((data) => {
          router.push(`/${category}/results/${data.id}`);
        });
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Head title={META_TITLE} canonicalPath={`/${category}/questions`} />
      <main>
        <div className={"text-center bg-[#FF9966] text-white py-20"}>
          <h1 className={"font-bold md:text-6xl text-2xl mb-3"}>
            「忙しい！」レベル診断
          </h1>
          <p className={"text-lg md:text-3xl"}>BUSY LEVEL TEST</p>
          <p className={"text-md md:text-2xl mt-8 tracking-wider"}>
            口癖のように「忙しい」と言っていませんか？
            <br />
            そんなあなたの忙しさを数値化して見てましょう。
            <br />
            忙しさを解消するヒントが得られますよ！
          </p>
        </div>
        <div className={"mb-10 max-w-[1440px] m-auto px-4 py-2"}>
          <Breadcrumb breadcrumbs={breadcrumbs} />
        </div>
        <div className={"max-w-[1280px] m-auto py-14 px-5"}>
          <QuestionsForm
            ItemizedQuestions={ItemizedQuestions}
            onSubmit={onSubmit}
            mainColor={MAIN_COLOR}
          />
        </div>
      </main>
    </>
  );
};

export async function getStaticProps() {
  return {
    props: {},
  };
}
export default BusyDiagnoseQuestionsPage;
